import { when } from 'mobx';
import { runtime } from '../../runtime/Runtime';
export class AppMode {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get app() {
        return this.parent;
    }
    get isInEditMode() {
        return runtime.solidBrowserRuntime.browserAddressBar.addressUrl.current.searchParams.get('edit') === '1';
    }
    async gotoEditMode(question) {
        await when(() => !!runtime.streamedPackages.Edit);
        this.app.solidEdit.editMode.gotoEditMode();
        if (!question)
            return;
        this.app.editQuestion = question;
    }
    get isInPreviewMode() {
        if (runtime.isServerRuntime)
            return false;
        return runtime.solidBrowserRuntime.browserAddressBar.addressUrl.current.searchParams.get('preview') === '1';
    }
}
